module.exports = __webpack_public_path__ + "static/reekon_features_autonomous_ticket_registration-97ab86a3df2dfc66c35f02203cc87b0a.svg";